import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import {
  trigger,
  state,
  transition,
  style,
  animate
} from '@angular/animations';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));

  @Component({
    selector: "app-sticky",
    templateUrl: "./index.html",
   // styleUrls: ["./styles.css"],
    animations: [
      trigger("fade", [
        state("void", style({ opacity: 0 })),
        transition(":enter", [animate(300)]),
        transition(":leave", [animate(500)])
      ])
    ]
  })
  export class HomeComponent implements OnInit {
    constructor(@Inject(DOCUMENT) document) {}
  
    ngOnInit() {}
  
    // @HostListener("window:scroll", ["$event"])
    // onWindowScroll(e) {
    //   if (window.pageYOffset > 250) {
    //     let element = document.getElementById("sticky-navbar");
    //     element.classList.add("sticky");
    //   } else {
    //     let element = document.getElementById("sticky-navbar");
    //     element.classList.remove("sticky");
    //   }
    // }
  }  
  declare module "@angular/core" {
    interface ModuleWithProviders<T = any> {
        ngModule: Type<T>;
        providers?: Provider[];
    }
}
declare global{
  interface Navigator {
    msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean
  }
}